import * as Yup from 'yup'
import {
  createValidation,
  MotivoCancelamentoAtendimentoType,
} from '../../../../../../../../_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'

export const marcarFaltaSchema = (t: TFunction) => {
  const v = createValidation(t)

  return Yup.object().shape({
    motivo: Yup.object().nullable().required(v.requiredField('motivo_falta', 'select')),
    motivoDetalhado: Yup.string()
      .trim()
      .when('motivo', {
        is: (motivo: { value?: string } | null) =>
          motivo?.value === MotivoCancelamentoAtendimentoType.Outros,
        then: (schema) => schema.required(v.requiredField('detalhes_falta')),
        otherwise: (schema) => schema.notRequired(),
      }),
  })
}
